import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdlViewerDrugSearchDataAccessModule } from '@cigna/pdl-viewer/drug-search/data-access';
import { PdlViewerDrugSearchFeatureModule } from '@cigna/pdl-viewer/drug-search/feature';
import { UiInputModule } from '@cigna/shared/angular/input-ui';
import { PdlViewerDrugSearchUiModule } from '@cigna/pdl-viewer/drug-search/ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiProgressModule } from '@cigna/shared/angular/progress-ui';
import { RouterModule } from '@angular/router';
import { ContentBundleName } from '@cigna/pdl-viewer/shared/util';
import { ContentResolver } from '@cigna/shared/angular/resource-content-data-access';
import { TranslateModule } from '@ngx-translate/core';

import { PdlViewerComponent } from './pdl-viewer/pdl-viewer.component';
import { PdlContentComponent } from './pdl-content/pdl-content.component';
import { UiResponsiveModule } from '@cigna/shared/angular/responsive-ui';

const DECLARATIONS = [PdlViewerComponent, PdlContentComponent];

/*
Following no longer used. possible cleanup in future
individuals-families/member-resources/prescription/chkout-drug-list
es-us/individuals-families/member-resources/prescription/chkout-drug-list

Pdl viewer not on this page anymore
individuals-families/member-resources/prescription/drug-list
es-us/individuals-families/member-resources/prescription/drug-list

redirects to new page
individuals-families/member-resources/prescription/ifp-drug-list
es-us/individuals-families/member-resources/prescription/ifp-drug-list
*/

@NgModule({
  imports: [
    CommonModule,
    PdlViewerDrugSearchDataAccessModule,
    PdlViewerDrugSearchFeatureModule,
    PdlViewerDrugSearchUiModule,
    UiInputModule,
    FormsModule,
    ReactiveFormsModule,
    UiProgressModule,
    TranslateModule,
    UiResponsiveModule,
    RouterModule.forChild([
      {
        path: 'individuals-families/member-resources/prescription/drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'nonIFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'individuals-families/member-resources/prescription/ifp-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'IFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'es-us/individuals-families/member-resources/prescription/ifp-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'IFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'es-us/individuals-families/member-resources/prescription/drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
        },
        resolve: {
          translation: ContentResolver,
          noQueryDefault: 'nonIFP',
        },
      },
      {
        path: 'es-us/individuals-families/member-resources/prescription/chkout-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'individuals-families/member-resources/prescription/chkout-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'pages/pdl-viewer.html',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'individuals-families/member-guide/individuals-families-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'IFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'es-us/individuals-families/member-guide/individuals-families-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'IFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'individuals-families/member-guide/offered-by-employers-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'nonIFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
      {
        path: 'es-us/individuals-families/member-guide/offered-by-employers-drug-list',
        component: PdlViewerComponent,
        data: {
          preloadContent: [ContentBundleName.PDL, ContentBundleName.PDF],
          noQueryDefault: 'nonIFP',
        },
        resolve: {
          translation: ContentResolver,
        },
      },
    ]),
  ],

  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class PdlViewerShellFeatureModule {}
